import {
  Directive,
  ElementRef,
  OnInit,
  Renderer2,
  inject,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { combineLatest } from 'rxjs';

@Directive({
  selector: '[appInputValidationStatus]',
  standalone: true,
})
export class InputValidationStatusDirective implements OnInit {
  private control = inject(NgControl);
  private renderer = inject(Renderer2);
  private el = inject(ElementRef);

  ngOnInit(): void {
    const element = this.el.nativeElement;
    const control = this.control.control;
    combineLatest([control.statusChanges, control.valueChanges]).subscribe(
      () => {
        this.renderer.removeClass(element, 'control-status-success');
        this.renderer.removeClass(element, 'control-status-danger');
        if (control && (control.dirty || control.touched)) {
          if (control.valid) {
            this.renderer.addClass(element, 'control-status-success');
          } else if (control.invalid) {
            this.renderer.addClass(element, 'control-status-danger');
          }
        }
      }
    );
  }
}
